<template>
  <div class="function-call">
    <b class="tool-name">{{ name }}</b>
    <div v-if="argsText">
      <span class="args-title">Arguments:</span>
      <span class="json-text">{{ argsText }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const { name, args } = defineProps({
  name: {
    type: String,
    required: true,
  },
  args: {
    type: String,
    required: false,
  },
});

const argsText = atob(args ?? '');
</script>

<style>
.function-call {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tool-name {
  display: block;
}

.args-title {
  display: block;
}

.json-text {
  display: block;
  padding: 8px 10px;
  font-family: ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, monospace;
  font-size: 0.85em;
  white-space: pre-wrap;
  word-break: break-word;
  background: var(--chatbot-inset-background);
  border: var(--chatbot-border-width) solid var(--chatbot-inset-border-color);
  border-radius: 4px;
}
</style>
